import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'

export const useIntersection = (
    element: React.RefObject<Element>,
    rootMargin: string
) => {
    const [inViewport, setIntersecting] = useState<boolean>(false)
    const [isAtBottom, setAtBottom] = useState<boolean>(false)
    const router = useRouter()

    useEffect(() => {
        let observer: IntersectionObserver | null = null

        const handleIntersection = (entries: IntersectionObserverEntry[]) => {
            const [entry] = entries
            setIntersecting(entry.isIntersecting)
        }

        const checkBottom = () => {
            if (element?.current) {
                const boundingRect = element.current.getBoundingClientRect()
                const viewportHeight = window.innerHeight
                setAtBottom(boundingRect.bottom <= viewportHeight)
            }
        }

        const initObserver = () => {
            if (element?.current) {
                observer = new IntersectionObserver(handleIntersection, {
                    rootMargin
                })
                observer.observe(element.current)
                window.addEventListener('scroll', checkBottom)
                window.addEventListener('touchmove', checkBottom)
                checkBottom()
            }
        }

        const disconnectObserver = () => {
            if (observer && element?.current) {
                observer.unobserve(element.current)
                observer.disconnect()
                window.removeEventListener('scroll', checkBottom)
                window.removeEventListener('touchmove', checkBottom)
            }
        }

        initObserver()

        return () => {
            disconnectObserver()
        }
    }, [element, rootMargin, router.asPath])

    return { inViewport, isAtBottom }
}
